<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>DESCANSO MEDICO</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{'tokenAtencion ' + tokenAtencion }}</span> -->

            <div 
              class="row d-flex align-items-center mt-1" 
              style="position: relative;"
            >
              <CommentEditor
                v-if="isAuditoria"
                field="procedimientos"
                :comentarios="comentarios"
              />
            </div>

            <div v-if="dataDescanso" class="row my-2">

              <div class="col-md-6">
                <div>
                  <b>Dias de descanso:</b> {{ dataDescanso.diasDescanso }}
                </div>
                
                <div> 
                  <b>Diagnostico a usar:</b> {{ dataDescanso.tipoDiagnostico }}
                </div>

                <div>
                  <b>Aislamiento:</b> {{ dataDescanso.aislamiento }}
                </div>
              </div>

              <div class="col-md-6">
                <div>
                  <b>Actividad laboral  :</b> {{ dataDescanso.actividadLaboral }}
                </div>

                <div>
                  <b>Empresa :</b> {{ dataDescanso.empresa }}
                </div>

                <div>
                  <b>Direccion:</b> {{ dataDescanso.direccion }}
                </div>
              </div>
              
              <div class="col-md-12 mt-1">
                <div>
                  <b>Tipo de contingencia:</b> {{ dataDescanso.tipoContingencia }}
                </div>
                
                <div>
                  <b>Observacion:</b>{{ dataDescanso.observacion }}
                </div>
              </div>
            </div>

            <EmptyResults
              v-if="!dataDescanso"
              :message="'No se encontro informacion de descanso medico.'"
            />
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { EmptyResults }          from '@/shared/components';
import { descansoMedicoService } from '@/views/atencionCita/services';
import { getItemByValueId }      from '@/shared/helpers';
import CommentEditor             from '../CommentEditor/CommentEditor.vue';

export default {
  name: "AtencionDescansoMedico",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    isAuditoria: {
      type: Boolean,
      default: false
    },
  },

  components: {
    EmptyResults,
    CommentEditor,
  },

  data() {
    return {
      visibleBody: false,

      dataDescanso:null,
      comentarios:{},

      aislamientoOpts: [
        { value: '1', text: "Ninguno"    },
        { value: '2', text: "Aislamiento" },
        { value: '3', text: "Teletrabajo" },
      ]

    };
  },

  created(){
    this.onGetData();
  },

  methods: {
    onVisibleBody() {
      this.visibleBody = !this.visibleBody
    },

    async onGetData(){
      const data = await descansoMedicoService.getByAtencion(this.tokenAtencion);
      if (!data) return;

      const dataMap = this.mapDescanso(data);
      console.log('el descanso medico', dataMap);

      this.dataDescanso = dataMap;
    },


    mapDescanso(data){
      const aislamiento = getItemByValueId(this.aislamientoOpts, data.aislamiento);

      return {
        diasDescanso     : data.diasdescanso,
        tipoDiagnostico  : data.tipodiagnostico?.descripcion,
        aislamiento      : aislamiento?.text,
        actividadLaboral : data.actividadlab,
        empresa          : data.empresa,
        direccion        : data.residencia?.callePrincipal,
        observacion      : data.observacion,
        tipoContingencia : data.contingencia
      }
    }
  },

  watch: {

    comentarios:{
      deep: true,
      handler(newValue) {
        const comentario = newValue.descansoMedico || null;
        this.$store.commit("setComentarios", { descansoMedico: comentario });
      }
    }
  }
}
</script>
